import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

function InvalidQRCode() {
  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        py: 4,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 4 },
          textAlign: 'center',
          backgroundColor: '#1e1e1e',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 2 }}>
          Invalid QR Code
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          The QR code you scanned is invalid or has expired. Please scan a valid QR code to access charger information.
        </Typography>
        <Box>
          <Typography variant="body2" color="text.secondary">
            If you believe this is an error, please contact support.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default InvalidQRCode;
